import { IpoIdentifierStatus } from '../../../../../types';

export const IPO_IDENTIFIER_TAG: Record<IpoIdentifierStatus, { label: string; tagClass: string }> = {
  PENDING: { label: 'Pending', tagClass: 'Pending' },
  CREATED: { label: 'Created', tagClass: 'Success' },
  CONFIRMED: { label: 'Confirmed', tagClass: 'Success' },
  FAILED: { label: 'Failed', tagClass: 'Failed' },
  NOT_REQUIRED: { label: 'Not required', tagClass: 'Reversed' },
  UNKNOWN: { label: 'Unknown', tagClass: 'Reversed' },
};

export const getIpoIdentifierTag = (status?: string | null) => {
  const key = (status || 'PENDING').toUpperCase() as IpoIdentifierStatus;
  return IPO_IDENTIFIER_TAG[key] || IPO_IDENTIFIER_TAG.UNKNOWN;
};
